// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class WorkPackage  {
    _originalTypeClassName = "Loom.BO.WorkPackage";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
WorkPackage.translate = translateService;
}
this.Tasks = [];
this.Participations = [];
this.Deliverables = [];
this.Id = null;
this.WPNumber = null;
this.Name = null;
this.StartMonth = null;
this.StartDate = null;
this.EndMonth = null;
this.EndDate = null;
this.DurationInMonths = null;
this.DescriptionOfWork = null;
this.Objectives = null;
this.TotalPersonMonthsBudgeted = null;
this.WPPercentage = null;
this.ClickUpListId = null;
this.ClickUpLink = null;
this.FQN = null;
this.WPNumberInt = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
WPNumber:any;
Name:any;
StartMonth:any;
StartDate:any;
EndMonth:any;
EndDate:any;
DurationInMonths:any;
DescriptionOfWork:any;
Objectives:any;
TotalPersonMonthsBudgeted:any;
WPPercentage:any;
ClickUpListId:any;
ClickUpLink:any;
FQN:any;
WPNumberInt:any;
Tasks:any;
Project:any;
Participations:any;
Deliverables:any;
static setTasks = ($this, items) => {
                if (items == null) items = [];
                if ($this.Tasks == null) $this.Tasks = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Tasks.length > 0) {
                    Domain.WorkPackage.removeTasks($this, $this.Tasks[0]);
                }

                Domain.WorkPackage.addManyTasks($this, copyItems);
            }
static addManyTasks = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.WorkPackage.addTasks($this, items[i]);
                }
            }
static addTasks = ($this, item) => {
                if ($this.Tasks == null) $this.Tasks = [];
                if (item == null || $this.Tasks.indexOf(item) > -1) return;
                $this.Tasks.push(item);
if (item.WorkPackage != $this) {
Domain.ProjectTask.setWorkPackage(item, $this);
}
}
static addRangeTasks = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.WorkPackage.addTasks($this, item));
            }
static removeTasks = ($this, item) => {
                if ($this == null || $this.Tasks == null || $this.Tasks.indexOf(item) === -1) return;
                var _index = $this.Tasks.indexOf(item);
                $this.Tasks.splice(_index, 1);
item.WorkPackage = null;
}
static clearTasks = ($this) => { $this.Tasks = null; }
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
if (oldValue != null) {
Domain.Project.removeWorkPackages(oldValue, $this);
}
Domain.Project.addWorkPackages(value, $this);
}
}
static setParticipations = ($this, items) => {
                if (items == null) items = [];
                if ($this.Participations == null) $this.Participations = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Participations.length > 0) {
                    Domain.WorkPackage.removeParticipations($this, $this.Participations[0]);
                }

                Domain.WorkPackage.addManyParticipations($this, copyItems);
            }
static addManyParticipations = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.WorkPackage.addParticipations($this, items[i]);
                }
            }
static addParticipations = ($this, item) => {
                if ($this.Participations == null) $this.Participations = [];
                if (item == null || $this.Participations.indexOf(item) > -1) return;
                $this.Participations.push(item);
if (item.WorkPackage != $this) {
Domain.ParticipantWorkAssignment.setWorkPackage(item, $this);
}
}
static addRangeParticipations = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.WorkPackage.addParticipations($this, item));
            }
static removeParticipations = ($this, item) => {
                if ($this == null || $this.Participations == null || $this.Participations.indexOf(item) === -1) return;
                var _index = $this.Participations.indexOf(item);
                $this.Participations.splice(_index, 1);
item.WorkPackage = null;
}
static clearParticipations = ($this) => { $this.Participations = null; }
static setDeliverables = ($this, items) => {
                if (items == null) items = [];
                if ($this.Deliverables == null) $this.Deliverables = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Deliverables.length > 0) {
                    Domain.WorkPackage.removeDeliverables($this, $this.Deliverables[0]);
                }

                Domain.WorkPackage.addManyDeliverables($this, copyItems);
            }
static addManyDeliverables = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.WorkPackage.addDeliverables($this, items[i]);
                }
            }
static addDeliverables = ($this, item) => {
                if ($this.Deliverables == null) $this.Deliverables = [];
                if (item == null || $this.Deliverables.indexOf(item) > -1) return;
                $this.Deliverables.push(item);
if (item.WorkPackage != $this) {
Domain.Deliverable.setWorkPackage(item, $this);
}
}
static addRangeDeliverables = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.WorkPackage.addDeliverables($this, item));
            }
static removeDeliverables = ($this, item) => {
                if ($this == null || $this.Deliverables == null || $this.Deliverables.indexOf(item) === -1) return;
                var _index = $this.Deliverables.indexOf(item);
                $this.Deliverables.splice(_index, 1);
item.WorkPackage = null;
}
static clearDeliverables = ($this) => { $this.Deliverables = null; }

static GetDueDate($this: any): any{let Time = Joove.Common.dateDiff(new Date(new Date($this?.EndDate)?.setHours(0, 0, 0, 0)), new Date(new Date(moment().toDate())?.setHours(0, 0, 0, 0)))?.days;
let result = "";
if (CLMS.Framework.Number.GreaterThan(() => Time, () => 30) && CLMS.Framework.Number.LessThan(() => Time, () => 365)) {Time = Joove.Common.safeNumber(Time) / Joove.Common.safeNumber(30);return Time?.toString() + " month(s) remaining";}else if (CLMS.Framework.Number.GreaterThanOrEqual(() => Time, () => 365)) {Time = Joove.Common.safeNumber(Time) / Joove.Common.safeNumber(365);return Time?.toString() + " year(s) remaining";}else if (CLMS.Framework.Number.GreaterThan(() => Time, () => 0)) {return Time?.toString() + " day(s) remaining";}else {return "Finished!";}
}
static GetDurationInMonths($this: any): any{return Joove.Common.safeNumber($this?.EndMonth) - Joove.Common.safeNumber($this?.StartMonth) + Joove.Common.safeNumber(1);
}
static GetEffortByParticipants($this: any, participantIds: any): any{if (participantIds == null || CLMS.Framework.Number.LessThanOrEqual(() => participantIds.length, () => 0)) {return $this?.TotalPersonMonthsBudgeted;}
return $this?.Participations?.linq?.where((p) => participantIds?.linq?.contains(p?.Participant?.Id))?.toArray()?.linq?.sum((p) => p?.Effort);
}
static GetEndDate($this: any): any{return Domain.Project.GetMonthDates($this?.Project, $this?.EndMonth)[1];
}
static GetFQN($this: any): any{return CLMS.Framework.String.Format("{0} - {1}", $this?.Project?.Acronym, $this?.WPNumber);
}
static GetStartDate($this: any): any{return Domain.Project.GetMonthDates($this?.Project, $this?.StartMonth)[0];
}
static GetWPNumberInt($this: any): any{let numText = Joove.Common.replaceAll(Joove.Common.replaceAll($this?.WPNumber, "WP", ""), "A", "");
try {let num = CLMS.Framework.Integer.Parse(numText);return num;}
catch (x) {console.warn("Error parsing WP number: " + $this?.WPNumber);return 0;}
}
static GetWPPercentage($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.EndMonth, () => 0) || CLMS.Framework.Number.LessThanOrEqual(() => Domain.WorkPackage.GetDurationInMonths($this), () => 0))) {return 0;}
let wpCurrMonth = Joove.Common.safeNumber($this?.Project?.CurrentMonth) - Joove.Common.safeNumber($this?.StartMonth) + Joove.Common.safeNumber(1);
if ((CLMS.Framework.Number.LessThan(() => wpCurrMonth, () => 0))) {return 0;}
return Joove.Common.safeNumber((parseFloat((wpCurrMonth) as any))) / Joove.Common.safeNumber((parseFloat((Domain.WorkPackage.GetDurationInMonths($this)) as any)));
}
static IsActiveInMonthRange($this: any, startMonth: any,endMonth: any): any{let overlap = CLMS.Framework.Number.LessThanOrEqual(() => startMonth, () => $this.EndMonth) && CLMS.Framework.Number.GreaterThanOrEqual(() => endMonth, () => $this.StartMonth);
return overlap;
}
static IsActiveInProjectMonth($this: any, month: any): any{return CLMS.Framework.Number.LessThanOrEqual(() => $this.StartMonth, () => month) && CLMS.Framework.Number.GreaterThanOrEqual(() => $this.EndMonth, () => month);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}